export class GetTrackedMedia {
  public static readonly type = '[Notifications] GetTrackedMedia';
}
